<template>
  <v-col cols="12" class="d-flex flex-column align-center">


    <v-btn variant="plain" class="d-flex flex-row align-center" @click="supportOfferClicked" style="cursor:pointer;">
      <v-icon><WarningSign /></v-icon>
      <span class="font-weight-bold ml-1 offer-support-button-text-color">Support</span>
    </v-btn>

    <SupportOfferDialog :support_info="supportInfo">
    </SupportOfferDialog>


  </v-col>
</template>



<script setup lang="ts">

import WarningSign from '@/icons/WarningSign.vue';
import { ref, computed, provide } from 'vue';
import SupportOfferDialog from './Support-Offer-Dialog.vue';
import { SupportInfo } from '@/interfaces/Offers/SupportInfo';

const supportDialogOpen = ref(false);
provide('supportDialogOpen', supportDialogOpen);

const props = defineProps({
    support_info: Object as () => SupportInfo,
});

const supportInfo = computed(() => props.support_info);

const supportOfferClicked = () => {
    supportDialogOpen.value = true;
};
</script>
